import React from "react";

const DrawerWidthContext = React.createContext();

export default DrawerWidthContext;
